import { getQueryStringFromOptions, getResponse } from '@satellite/services/serviceUtilities';
import { cachedInflightRequest } from '@nova/core';

export default {
  async createYardTask(params, options = {}, requestConfig = {}) {
    const response = await axios.post('/yard-task', params, requestConfig);

    return getResponse(response, options);
  },
  async getYardTasksGrid(params = {}, options = {}, requestConfig = {}) {
    const queryString = getQueryStringFromOptions(options);

    const cacheKey = `yard-task/grid:${JSON.stringify(params)}:${queryString}`;

    return cachedInflightRequest(cacheKey, async () => {
      const response = await axios.get(`/yard-task/grid?${queryString}`, {
        params,
        ...requestConfig
      });

      return getResponse(response, options);
    });
  },

  async getYardTaskList(params = {}, options = {}, requestConfig = {}) {
    const queryString = getQueryStringFromOptions(options);

    const cacheKey = `yard-task/list:${JSON.stringify(params)}:${queryString}`;

    return cachedInflightRequest(cacheKey, async () => {
      const response = await axios.get(`/yard-task?${queryString}`, {
        params,
        ...requestConfig
      });

      return getResponse(response, options);
    });
  },

  async getYardTask(taskId, options = {}, requestConfig = {}) {
    const response = await axios.get(`/yard-task/${taskId}`, {
      ...requestConfig
    });

    return getResponse(response, options);
  },

  async updateYardTask(taskId, params, options = {}, requestConfig = {}) {
    const response = await axios.patch(`/yard-task/${taskId}`, params, requestConfig);
    return getResponse(response, options);
  }
};
